import React, { createContext, useState, useContext, useEffect } from "react";
import { db } from "../firebase";
import {
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  onSnapshot,
} from "firebase/firestore";
import { UserAuth } from "./AuthContext";

const SavedSeriesContext = createContext();

export const useSavedSeries = () => {
  return useContext(SavedSeriesContext);
};

export const SavedSeriesProvider = ({ children }) => {
  const { user } = UserAuth();
  const [savedSeries, setSavedSeries] = useState([]);

  useEffect(() => {
    if (!user?.uid) {
      setSavedSeries([]);
      return;
    }

    const userDocRef = doc(db, "users", user.uid);

    const unsubscribe = onSnapshot(userDocRef, (docSnap) => {
      if (docSnap.exists()) {
        setSavedSeries(docSnap.data().savedSeries || []);
      }
    });

    return () => unsubscribe();
  }, [user?.uid]);

  const saveSeries = async (series) => {
    if (!user?.uid || !series?.id) return;
    const userDocRef = doc(db, "users", user.uid);

    try {
      await updateDoc(userDocRef, {
        savedSeries: arrayUnion(series),
      });
    } catch (error) {
      console.error("Error saving series:", error);
    }
  };

  const removeSeries = async (series) => {
    if (!user?.uid || !series?.id) return;
    const userDocRef = doc(db, "users", user.uid);

    try {
      await updateDoc(userDocRef, {
        savedSeries: arrayRemove(series),
      });
    } catch (error) {
      console.error("Error removing series:", error);
    }
  };

  return (
    <SavedSeriesContext.Provider value={{ savedSeries, saveSeries, removeSeries }}>
      {children}
    </SavedSeriesContext.Provider>
  );
};
